<template>
    <v-container
        fluid
    >
        <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
            class="d-flex justify-center align-center my-4 mx-auto"
        ></v-progress-circular>
        <v-alert
            v-else
            class="display-1"
            transition="scale-transition"
            :icon="tempoEstimado ? 'mdi-clock-outline' : 'mdi-alert-outline'"
            :color="tempoEstimado ? 'primary' : 'error'"
            dark
            id="tempo-estimado-conciliacao-container"
        >
            <div v-if="tempoEstimado">
                Com base nos parâmetros definidos, o tempo <strong class="text-uppercase">estimado</strong> para o 
                processamento desta conciliação é de aproximadamente:
                <div class="display-2 text-center my-3 font-weight-bold">{{ tempoEstimado }}</div>
            </div>
            <div v-else>
                Não foi possível obter a estimativa de tempo para esta conciliação.
            </div>
        </v-alert>
    </v-container>
</template>

<script>
export default {
    name: 'TempoEstimadoConciliacaoAlert',
    props: {
        loading: {
            type: Boolean,
            default: false 
        },
        tempoEstimado: {
            type: String,
            default: null
        }
    }
}
</script>